/**
 * TODO: NodeJS upgrade with microfrontend architecture - Move these to environemnt variables once a separate pod will be created for this.
 */
const config = {
  USE_LOCAL_MOCK_API: false,
  URL_OB_NEXT_GEN: '/integrations',
  URL_OB_NEXT_GEN_DISCOVERY: '/integrations/discovery',
  URL_OB_NEXT_GEN_DISCOVERY_CONFIG: '/integrations/discovery/config',
  URL_OB_NEXT_GEN_GRAPHS_POC: '/integrations/graphs',
  URL_INTEGRATIONS_COPILOT: '/integrations/copilot',
};

export default config;
